import React from "react";

export default function TitleDescriptionItem({
  title,
  description,
  leftLine,
  img,
}: {
  title: string;
  description: string;
  leftLine?: boolean;
  img?: any;
}) {
  return (
    <div
      className={`group ${
        leftLine ? "border-l border-secondary-dark/30 pl-5" : ""
      } transition-colors duration-300 hover:border-main`}
    >
      {img && (
        <img
          className="h-14 mb-5 object-contain grayscale opacity-80 transition-all duration-300 group-hover:grayscale-0 group-hover:opacity-100"
          src={img.src}
          alt={img.alt}
        />
      )}
      {title && (
        <p className="font-header text-xl sm:text-2xl leading-snug text-secondary-dark transition-colors duration-300 group-hover:text-main">
          {title}
        </p>
      )}
      {description && (
        <p className="mt-3 font-text font-light text-[14.5px] leading-7 text-secondary-dark/80">
          {description}
        </p>
      )}
    </div>
  );
}
